import * as uuid from 'uuid';

const TRACKING_ENABLED = false;

export class Storage {
  static getStartingLevel(): number {
    const storedLevelNum = localStorage.getItem('startLevel');
    if (storedLevelNum !== null) {
      return Number(storedLevelNum);
    } else {
      return 0;
    }
  }

  static setStartingLevel(level: number): void {
    if (TRACKING_ENABLED) {
      localStorage.setItem('startLevel', String(level));
    }
  }

  static hasConsented(): boolean {
    const consent = localStorage.getItem('consent');
    return consent != null && Boolean(consent);
  }

  static giveConsent(): void {
    if (TRACKING_ENABLED) {
      localStorage.setItem('consent', 'true');
    }
  }
  static getUUID(): string {
    const id = localStorage.getItem('uuid');
    if (id === null) {
      const newId = uuid.v1();
      if (TRACKING_ENABLED) {
        localStorage.setItem('uuid', newId);
      }
      return newId;
    } else {
      return id;
    }
  }
}

export type Message = LevelCompleteMessage;

export interface CommonMessage {
  uid: string;
}

export interface LevelCompleteMessage extends CommonMessage {
  levelNum: number;
  levelName: string;
  movesUsed: number;
  movesRequired: number;
}

export class MetricTracker {
  /** This sends the message parameter to this trackers
   *  tracking endpoint. It returns true if successful
   *  and false if the message failed to send.
   */
  sendMessage(message: Message): boolean {
    if (TRACKING_ENABLED) {
      console.log(message);
    }
    return true;
  }
}
